import { NavLink, Outlet, useOutletContext } from "react-router-dom";
import { BarChart3, DollarSign, FileCheck2, LayoutGrid, ScrollText } from "lucide-react";

const tabs = [
  { to: "/dashboard/affiliate", label: "Overview", icon: LayoutGrid, end: true, testid: "aff-tab-overview" },
  { to: "/dashboard/affiliate/orders", label: "Orders", icon: FileCheck2, testid: "aff-tab-orders" },
  { to: "/dashboard/affiliate/payouts", label: "Payouts", icon: DollarSign, testid: "aff-tab-payouts" },
  { to: "/dashboard/affiliate/performance", label: "Performance", icon: BarChart3, testid: "aff-tab-performance" },
  { to: "/dashboard/affiliate/terms", label: "Program Terms", icon: ScrollText, testid: "aff-tab-terms" },
];

export default function AffiliateShell() {
  const ctx = useOutletContext() || {};
  const { affiliate, affLoaded } = ctx;
  const active = affiliate && ["active", "paused"].includes(affiliate.status);

  return (
    <div data-testid="affiliate-portal">
      <div className="mb-6">
        <div className="eyebrow mb-2">Affiliate Program</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-slate-900 tracking-tight">
          Your Affiliate Portal
        </h1>
        <p className="mt-1 text-slate-600 text-sm">
          Share your link, watch your earnings, and grow with every referred order.
        </p>
      </div>

      {active && (
        <nav
          data-testid="affiliate-subnav"
          className="mb-6 border border-slate-200 rounded-md bg-white p-1 flex flex-wrap gap-1 overflow-x-auto"
        >
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-mono uppercase tracking-widest transition-colors whitespace-nowrap ${
                  isActive ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <t.icon className="w-3.5 h-3.5" strokeWidth={1.75} /> {t.label}
            </NavLink>
          ))}
        </nav>
      )}

      <Outlet context={ctx} />

      {!affLoaded && (
        <div className="text-slate-400 font-mono text-xs uppercase tracking-widest">Loading portal…</div>
      )}
    </div>
  );
}
